import getId from "Areas/SharedFeatures/types/utils/getId";
import { DOCUMENT_TYPE } from "Common/dictionaries/documentType";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import React, { useCallback, useEffect, useMemo } from "react";
import { SidebarMenuList } from "../../Common";
import buildNavigationSidebarItems, { buildNavigationObjectKey } from "../utils/buildNavigationSidebarItems";
import locale from "./tabNavigation.locale";
export default function TabNavigation(props) {
    useEffect(() => {
        props.onInitialized && props.onInitialized();
    }, [props.onInitialized]);
    const sidebarMenuItems = useMemo(() => {
        if (!props.activeDocumentId)
            return [];
        return props.documentType && props.navigationObjects && props.documentObjects
            ? buildNavigationSidebarItems(props.documentType, props.documentObjects, props.navigationObjects.nodesSource, props.navigationObjects.tableRow, props.navigationObjects.mapObject)
            : undefined;
    }, [props.documentType, props.navigationObjects, props.documentObjects, props.activeDocumentId]);
    const selectedItems = useMemo(() => new Set([...map(props.selectedIds, buildNavigationObjectKey), ...(props.selectedIds || [])]), [props.selectedIds]);
    const emptyText = !props.activeDocumentId
        ? locale.SELECT_DOCUMENT
        : isEmpty(sidebarMenuItems)
            ? locale.NO_NAVIGATION_OBJECTS
            : "";
    const handleItemClick = useCallback((item) => {
        if (!item.sourceData)
            return;
        if (props.documentType === DOCUMENT_TYPE.TABLE) {
            const rowId = item.sourceData.id;
            rowId && props.onNavigateTo && props.onNavigateTo(rowId);
        }
        else if (props.documentType === DOCUMENT_TYPE.GRAPH) {
            const nodeId = item.sourceData.NodeId;
            nodeId && props.onNavigateTo && props.onNavigateTo(nodeId);
        }
        else if (props.documentType === DOCUMENT_TYPE.MAP) {
            const mapObjectId = getId(item.sourceData);
            mapObjectId && props.onNavigateTo && props.onNavigateTo(mapObjectId);
        }
    }, [props.onNavigateTo, props.documentType]);
    const sidebarMenuList = useMemo(() => (React.createElement(SidebarMenuList, { className: props.className, bgColorDefault: props.bgColorDefault, bgColorActive: props.bgColorActive, inProgress: props.inProgress, sidebarMenuItems: sidebarMenuItems, emptyText: emptyText, selectedItems: selectedItems, activeItems: selectedItems, onItemClick: handleItemClick, filterText: props.filterText, sortBy: props.sortBy, sortOrder: props.sortOrder, smallMargins: true })), [
        props.className,
        props.bgColorDefault,
        props.bgColorActive,
        props.inProgress,
        props.filterText,
        props.sortBy,
        props.sortOrder,
        sidebarMenuItems,
        emptyText,
        selectedItems,
        handleItemClick
    ]);
    return sidebarMenuList;
}
